import { useState, useEffect } from 'react'
// components
import { Button, Search } from 'carbon-components-react';
// import cogoToast from 'cogo-toast'
import LocationsGrid from './LocationsGrid'
import LocationDetailModal from './LocationDetailModal'
import ConfirmModal from '../../components/Modal/ConfirmModal'
// api
import {
  addLocation,
  updateLocation,
  deleteLocation,
} from '../../api/locations'
import { toaster } from '../../helpers/toaster';

const useLocationsGrid = ({
  isStudyDetail,
  studyLocation,
  setStudyDetails,
  studyPgId,
  studyOrgStudyId,
} = {}) => {
  const [locationData, setLocationData] = useState(null);
  const [locationId, setLocationId] = useState(null)
  const [deleteItemId, setDeleteItemId] = useState(null)
  const [locationsLoading, setLocationsLoading] = useState(false)
  // modals
  const [detailModalMode, setDetailModalMode] = useState("")
  const [openLocationModal, setOpenLocationModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  //url params
  const [searchGrid, setSearchGrid] = useState("")
  const [search, setSearch] = useState("");
  const [refreshData, setRefreshData] = useState(false);
  const [sort, setSort] = useState("");
  const onlyAttachment = localStorage.getItem('only_attachment')
  const addLocationBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px"
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true)
    setDeleteItemId(itemId)
  }

  const addNewLocation = () => {
    setDetailModalMode("create")
    setLocationData(null)
    setOpenLocationModal(true)
  }

  const confirmSave = (locInfo) => {
    setLocationsLoading(true);
    return addLocation(locInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && studyLocation && res.data) {
        setStudyDetails({
          type: 'ADD_ITEM',
          itemType: 'locations',
          item: res.data,
        })
      }

      // for locations list page
      setRefreshData(true)
      toaster("Location created successfully", "success")
      setLocationsLoading(false);
      setOpenLocationModal(false)
      return res.data
    }).catch(error => {
      console.log('confirmSave error', error)
      toaster("Failed to create location", "error")
      setLocationsLoading(false);
      setOpenLocationModal(false)
    });
  }

  const confirmUpdate = (locationId, locationInfo) => {
    updateLocation(locationId, locationInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && studyLocation && res.data) {
        setStudyDetails({
          type: 'UPDATE_ITEM',
          itemType: 'locations',
          item: res.data,
        })
      }

      // for locations list page
      setRefreshData(true)
      toaster("Location updated successfully", "success")
      setLocationsLoading(false);
    }).catch(error => {
      console.log('confirmUpdate error', error)
      toaster("Failed to update location", "error")
      setLocationsLoading(false);
    });
    setOpenLocationModal(false)
  }

  const confirmDelete = () => {
    setOpenDeleteModal(false)
    setLocationsLoading(true)
    deleteLocation(deleteItemId).then(res => {

      // for grid on study details page
      if (isStudyDetail && studyLocation) {
        setStudyDetails({
          type: 'DELETE_ITEM',
          itemType: 'locations',
          id: deleteItemId,
        })
      }

      // for locations list page
      setRefreshData(true);

      toaster("Location deleted successfully", "success")
      setLocationsLoading(false);
    })
  }

  /** EVENT HANDLERS */

  const locationRowClicked = (data) => {
    setDetailModalMode("update")
    setLocationId(data.id)
    setLocationData(data)
    setOpenLocationModal(true)
  }

  /** COMPONENTS */

  const addLocationButton = () => {
    return <Button
      kind="primary"
      onClick={addNewLocation}
      style={addLocationBtnStyle}
      disabled={onlyAttachment === "true"}
    >
      Add Location
    </Button>
  }

  const locationSearch = () => {
    return <div style={{ width: "300px" }}>
      <Search
        size="sm"
        value={search}
        labelText="search"
        onChange={e => setSearch(e.target.value)}
        placeHolderText="Search using any data value" />
    </div>
  }

  const locationsGrid = () => {
    return <>
      <LocationsGrid
        locationsList={studyLocation}
        search={searchGrid}
        onRowClicked={locationRowClicked}
        onDeleteClicked={showDeleteConfirm}
        setRefresh={setRefreshData}
        refresh={refreshData}
        sort={sort}
        setSort={setSort}
        isStudyDetail={isStudyDetail}
      />
      <LocationDetailModal
        mode={detailModalMode}
        locationId={locationId}
        open={openLocationModal}
        locationData={locationData}
        onClose={() => setOpenLocationModal(false)}
        confirmSave={confirmSave}
        confirmUpdate={confirmUpdate}
        locationsLoading={locationsLoading}
        setLocationsLoading={setLocationsLoading}
        isStudyDetail={isStudyDetail}
        studyOrgStudyId={isStudyDetail ? studyOrgStudyId : null}
        studyPgId={isStudyDetail ? studyPgId : null}
      />
      <ConfirmModal
        title="Confirmation"
        content="Are you sure you want to delete location?"
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={() => confirmDelete()}
      />
    </>
  }

  return {
    addLocationButton,
    locationSearch,
    locationsGrid,
    locationsLoading,
    setLocationsLoading,
  }
}

export default useLocationsGrid